/** "Dana finished reviewing", "Dana and Sam ...", "Dana and 2 others ...". Null when nobody has. */
export function clientReviewDoneLabel(names) {
    if (!names || names.length === 0)
        return null;
    if (names.length === 1)
        return `${names[0]} finished reviewing`;
    if (names.length === 2)
        return `${names[0]} and ${names[1]} finished reviewing`;
    return `${names[0]} and ${names.length - 1} others finished reviewing`;
}
//# sourceMappingURL=clientReview.js.map